import { render, staticRenderFns } from "./PopupIntroCModal.vue?vue&type=template&id=1d506081&scoped=true"
import script from "./PopupIntroCModal.vue?vue&type=script&lang=js"
export * from "./PopupIntroCModal.vue?vue&type=script&lang=js"
import style0 from "./PopupIntroCModal.vue?vue&type=style&index=0&id=1d506081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d506081",
  null
  
)

export default component.exports